import ClowncarAppConstants from '../constants/ClowncarAppConstants';

const initialState = {
  isInitialized: false,
  partners: null,
  requestInProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.PARTNER_INSERT_STARTING:
    case ClowncarAppConstants.PARTNER_FETCH_ALL_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case ClowncarAppConstants.PARTNER_INSERT_DONE: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case ClowncarAppConstants.PARTNER_FETCH_ALL_DONE: {
      return {
        ...state,
        requestInProgress: false,
        isInitialized: true,
        partners: payload,
      };
    }
    default:
      return state;
  }
}
